<script setup lang="ts">
import type { FormModel as InternalLinksModel } from '../../../../pages/cms/marketing/internal-links/_runtime/services/InternalLinksService';
import InternalLinksService from '../../../../pages/cms/marketing/internal-links/_runtime/services/InternalLinksService';
import { useWebsitesStore } from '../../../../pages/cms/management/websites/_runtime/stores/websites';

const model = defineModel<string>({ default: '' });

const emit = defineEmits<{
    (e: 'onConnectLinks', ids: number[]): void;
}>();

const { $log } = useLogging();
const { $alert } = useAlerts();
const websitesStore = useWebsitesStore();

defineExpose({
    init(editor: any)
    {
        editor.ui.registry.addMenuItem('connectlinks', {
            icon: 'link',
            text: $t('[[[Podłącz linki wewnętrzne]]]'),
            onAction: async (): Promise<void> =>
            {
                try
                {
                    const response = await InternalLinksService.getOccurrence(
                        websitesStore.current.website,
                        websitesStore.current.locale,
                        model.value
                    );

                    let text = model.value;

                    response.forEach((el: InternalLinksModel) =>
                    {
                        const regex = new RegExp(`\\b${el.phrase}\\b(?!(?:(?!</?a[^>]*>).)*</a>)`, 'gi');

                        text = text.replace(regex, (match: string) => `<a href="${el.url}" target="${el.target}" rel="${el.nofollow ? 'nofollow' : 'follow'}" data-link-id="${el.id}">${match}</a>`);
                    });

                    model.value = text;

                    $alert.success($t('[[[Linki wewnętrzne zostały pomyślnie połączone.]]]'));

                    emit('onConnectLinks', response.map((el: InternalLinksModel) => el.id));
                }
                catch (ex)
                {
                    handleException($log, ex, {
                        400: (ex: any) => $alert.warning(ex.message)
                    });
                }
            }
        });
    }
});
</script>

<template>
    <div v-if="false" />
</template>
